<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useSiteStore } from '../stores/site'

const glow = ref<HTMLDivElement>()
const site = useSiteStore()
let frame = 0
const glowRadius = 260
const lightGlowRadius = 160

onMounted(() => {
  if (!glow.value || matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(pointer: fine)').matches) return
  const radius = site.theme.appearance === 'light' ? lightGlowRadius : glowRadius
  let mouseX = -radius
  let mouseY = -radius
  let glowX = -radius
  let glowY = -radius

  const move = (event: MouseEvent) => {
    mouseX = event.clientX
    mouseY = event.clientY
    if (glow.value) glow.value.dataset.active = 'true'
  }
  const animate = () => {
    glowX += (mouseX - glowX) * 0.1
    glowY += (mouseY - glowY) * 0.1
    if (glow.value) glow.value.style.transform = `translate(${glowX - radius}px,${glowY - radius}px)`
    frame = requestAnimationFrame(animate)
  }

  document.addEventListener('mousemove', move)
  animate()
  onBeforeUnmount(() => {
    cancelAnimationFrame(frame)
    document.removeEventListener('mousemove', move)
  })
})
</script>

<template><div ref="glow" class="mouse-glow" aria-hidden="true" /></template>
